import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { HiOutlinePlay, HiOutlineTrash } from "react-icons/hi2";

import { IconButton } from "../../../../components";
import { formatBytes, formatUploadSpeed } from "../IntroMediaUpload.utils";
import { FileIcon } from "./FileIcon";
import { disabledButtonStyles, enabledButtonStyles } from "./styles";

type UploadingContentProps = {
  fileName: string;
  fileType: string;
  fileSizeBytes?: number;
  progress: number;
  uploadSpeed?: number;
  readOnly?: boolean;
  onCancel?: () => void;
};

export const UploadingContent: React.FC<UploadingContentProps> = ({
  fileName,
  fileType,
  fileSizeBytes,
  progress,
  uploadSpeed,
  readOnly,
  onCancel,
}) => (
  <HStack justify="space-between" spacing={6} align="flex-start" width="100%">
    <HStack spacing={4} align="flex-start" flex="1" minW={0}>
      <FileIcon fileType={fileType} size="sm" />
      <VStack align="start" spacing={1} flex="1" minW={0}>
        <Box maxW="100%" overflow="hidden">
          <Text
            fontSize="sm"
            fontWeight="semibold"
            color="gray.900"
            lineHeight={5}
            display="inline"
            noOfLines={1}
          >
            {fileName}
            {fileSizeBytes && (
              <Text as="span" fontWeight="normal" color="gray.600">
                {" "}
                • {formatBytes(fileSizeBytes)}
              </Text>
            )}
          </Text>
        </Box>
        <VStack align="start" spacing={1} width="100%">
          <Box
            width="400px"
            maxW="100%"
            height={2}
            borderRadius="full"
            bg="gray.100"
            position="relative"
            overflow="hidden"
          >
            <Box
              height="100%"
              width={`${progress * 100}%`}
              borderRadius="full"
              bg="blue.500"
            />
          </Box>
          <HStack
            spacing={2}
            py={1}
            width="400px"
            maxW="100%"
            justify="space-between"
            align="center"
          >
            <Text fontSize="sm" color="gray.600" lineHeight={5}>
              {Math.round(progress * 100)}% done
            </Text>
            {uploadSpeed && (
              <Text fontSize="sm" color="gray.600" lineHeight={5}>
                {formatUploadSpeed(uploadSpeed)}
              </Text>
            )}
          </HStack>
        </VStack>
      </VStack>
    </HStack>
    {!readOnly && (
      <VStack spacing={2} align="center" justify="center" flexShrink={0}>
        <IconButton
          aria-label="Play"
          icon={<HiOutlinePlay size={16} />}
          {...disabledButtonStyles}
          size="xs"
          borderRadius="sm"
          minW={6}
          width={6}
          height={6}
          p={1}
          isDisabled
        />
        <IconButton
          aria-label="Cancel upload"
          icon={<HiOutlineTrash size={16} />}
          {...enabledButtonStyles}
          size="xs"
          borderRadius="sm"
          minW={6}
          width={6}
          height={6}
          p={1}
          onClick={onCancel}
        />
      </VStack>
    )}
  </HStack>
);
